import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { PersistentActions } from '../actions/PersistentActions';
import { PersistentStore } from '../stores/PersistentStore';

export class SelectionImageFormat extends SelectionBase {
    protected id: string = 'image-format-select';

    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: PersistentStore.getState().imageFormat,
            enabled: true,
            visible: true
        });
    };

    protected getLabel(): string {
        return t('Image Export');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {key: 'JPG', name: 'JPG', className: 'egr-select-option-noicon', callback: () => {PersistentActions.setImageFormat('JPG'); }},
            {key: 'PNG', name: 'PNG', className: 'egr-select-option-noicon', callback: () => {PersistentActions.setImageFormat('PNG'); }},
            {
                key: 'PNG*',
                name: t('{{imageFormat}} with transparent background', {imageFormat: 'PNG'}),
                className: 'egr-select-option-noicon',
                callback: () => {PersistentActions.setImageFormat('PNG*'); }
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionImageFormat.tsx